<template>
  <el-menu default-active="/main/goodsview" :default-openeds="['1','2','3']" style="min-height: 100%; overflow-x: hidden"
           background-color="rgb(48,65,86)"
           text-color="#fff" active-text-color="#dc8" router>
    <div style="height: 60px;line-height: 60px; text-align: center">
      <img src="../assets/logo.png" alt="" style="width: 20px; position: relative;top: 5px; margin-right: 5px">
      <b style="color: white">后台管理系统</b>
    </div>

    <el-submenu :collapse="true" index="1">
      <template slot="title"><i class="el-icon-user"></i>代理中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/agentview">代理管理</el-menu-item>
        <el-menu-item index="/main/agentbinddouyin">代理绑定抖音号</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu :collapse="true" index="2">
      <template slot="title"><i class="el-icon-goods"></i>产品中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/goodstypeview">产品分类</el-menu-item>
        <el-menu-item index="/main/goodsview">产品管理</el-menu-item>
        <el-menu-item index="/main/goodsliveview">抖音直播产品</el-menu-item>
        <el-menu-item index="/main/goodsliveksview">快手直播产品</el-menu-item>
        <el-menu-item index="/main/goodsoutview">产品回收站</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu :collapse="true" index="3">
      <template slot="title"><i class="el-icon-trophy"></i>订单中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/orderview">订单管理</el-menu-item>
        <el-menu-item index="/main/ordertestview">测试订单管理</el-menu-item>
        <el-menu-item index="/main/orderbatview">订单批量操作</el-menu-item>
        <el-menu-item index="/main/ordermanagerview">代理订单报表</el-menu-item>
        <el-menu-item index="/main/moneylog">提现记录</el-menu-item>
        <el-menu-item index="/main/ordercommissionview">佣金统计</el-menu-item>
        <el-menu-item index="/main/ordernotirecordview">敢探号推送记录</el-menu-item>
        <el-menu-item index="/main/ordernotirecordyunhaokaview">云号卡推送记录</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu :collapse="true" index="4">
      <template slot="title"><i class="el-icon-trophy"></i>代理商管理</template>
      <el-menu-item-group>
        <el-menu-item index="/main/userproxyview">代理商</el-menu-item>
        <el-menu-item index="/main/userproxyorderview">代理商订单</el-menu-item>
        <el-menu-item index="/main/userproxyorderbatview">订单批量操作</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu :collapse="true" index="5">
      <template slot="title"><i class="el-icon-user"></i>其它</template>
      <el-menu-item-group>
        <el-menu-item index="/main/otheractview">福利主页</el-menu-item>
        <el-menu-item index="/main/othercreditcardview">信用卡产品</el-menu-item>
        <el-menu-item index="/main/othercustomview">自定义</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Aside'
}
</script>

<style scoped>

</style>
